import {
  COMPONENT_VALUE_TYPES as types,
  COMPONENT_COLOR_THEMES,
} from 'shared/constants';

const propsSchema = [
    {
    key: 'theme',
    label: 'Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  },
  {
    key: 'visibleOnMobile',
    label: 'Visible on Mobile',
    type: types.BOOLEAN
  },
  {
    key: 'sections',
    label: 'Sections',
    type: types.ARRAY,
    children: [
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT
      },
      {
        key: 'items',
        label: 'Items',
        type: types.ARRAY,
        children: [
          {
            key: 'text',
            label: 'Text',
            type: types.TEXTAREA
          }
        ]
      }
    ]
  }
];

const defaultProps = {
  theme: 'DARK',
  visibleOnMobile: false,
  sections: [
    {
      title: 'Professional',
      items: [
        {
          text: 'Opportunities to work alongside some of the most accomplished minds in the industry'
        },
        {
          text: 'Modern workspace incorporating the latest technologies'
        },
        {
          text: 'Engaging internship program'
        },
        {
          text: 'Employee referral program'
        },
        {
          text: 'Engineering orientation and onboarding program'
        },
        {
          text: 'Paid relocation'
        },
        {
          text: '401k retirement plan'
        },
        {
          text: 'Generous healthcare, vision, and dental care – free to employees and discounted for partners and families'
        },
        {
          text: 'Stock options'
        },
        {
          text: 'Competitive salaries'
        }
      ]
    },
    {
      title: 'Personal',
      items: [
        {
          text: 'Foosball and ping pong tables – including tournaments'
        },
        {
          text: 'Frequent social events, happy hours, and team parties'
        },
        {
          text: '“Soul of Faraday” community outreach team'
        },
        {
          text: 'Culturally diverse, progressive atmosphere'
        },
        {
          text: 'Casual dress code and relaxed work environment'
        },
        {
          text: 'Free parking – with carpool reimbursement'
        },
        {
          text: 'Daily catered lunches and food trucks'
        }
      ]
    }
  ]
};

export default {
  title: 'Titled Item List',
  id: 'TitledItemList',
  propsSchema,
  defaultProps
};
